import { UserLocationMapper } from "@/javascript/infra/mappers/user-location-mapper"

export const makeUserLocationMapper = (): UserLocationMapper => {
  return new UserLocationMapper()
}
